<template>
  <div>
    <GlobalChatBot v-if="showChatBot == 1" />
    <div
      class="left-0 bottom-0 z-index-11 px-4 d-flex skip-capture align-center bg-transparent fixed"
      v-if="window.is_user_tester"
    >
      <div class="pa-0 ma-0 px-2 fs-14 py-1 grey--text">
        V.{{ siteVersion }}
        <template v-if="window?.gke_footer_text"> ({{ window?.gke_footer_text }}) </template>
      </div>
    </div>
  </div>
</template>

<script>
import GlobalChatBot from "@/components/global/GlobalChatBot.vue";
import { mapState } from "vuex";

export default {
  name: "GlobalFooter",
  components: { GlobalChatBot },
  computed: {
    ...mapState({
      window: (state) => state.window,
    }),
    showChatBot() {
      return window.vue_chat_bot_display;
    },
    showFooter() {
      return !window.partner_blankfooter_config;
    },
    siteVersion() {
      return this.$store.state.window?.current_release_version;
    },
    copyrightText() {
      return this.$store.state.window?.copyrighttext;
    },
    footerYear() {
      return new Date().getFullYear();
    },
  },
};
</script>

<style lang="scss"></style>
